import { changeComponentMap } from '@rd-lib/component-map';
import { WestpacOfferListingBannerComponent } from '@rd/wl/westpac/components/offer/listing-offer/listing-banner.component';

changeComponentMap({
  'rd-offer-listing-banner': WestpacOfferListingBannerComponent,
});
